import { ArrowForward } from '@mui/icons-material';
import { Stack } from '@mui/material';
import Button from '@mui/material/Button';
import { OutlinedTextField } from '@my2n/react-hook-form-inputs';
import { FormProvider } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { RouterLink } from '../../../ResetPasswordPage/components/Link/PrimaryLink';
import messages from './messages';
import { useMFAForm } from './useMFAForm';
import { FormFieldNames } from './validationScheme';

export interface IMFAFormProps {
  onMFARecovery: () => void;
  onSuccess?: () => void;
}

export function MFAForm(props: IMFAFormProps) {
  const { formatMessage, formData, formSubmit, isOryApiFetching } = useMFAForm({
    onSuccess: props.onSuccess,
  });

  return (
    <FormProvider {...formData}>
      <form onSubmit={formData.handleSubmit(formSubmit)}>
        <OutlinedTextField
          label={formatMessage(messages.ImsTwoFactorAuthenticationAuthCodeTitle)}
          name={FormFieldNames.TotpCode}
          required
          fullWidth
          helperText={formatMessage(messages.ImsTwoFactorAuthenticationAuthCodeHelper)}
        />
        <Stack spacing={2} mt={1}>
          <Button
            disabled={!formData.formState.isValid || isOryApiFetching}
            fullWidth
            color="primary"
            id="TOTP-submit"
            size="large"
            startIcon={<ArrowForward />}
            type="submit"
            variant="contained"
          >
            <FormattedMessage {...messages.ImsTwoFactorAuthenticationConfirm} />
          </Button>
          <RouterLink onClick={() => props.onMFARecovery()} to="">
            <FormattedMessage {...messages.ImsTwoFactorAuthenticationCantAccess} />
          </RouterLink>
        </Stack>
      </form>
    </FormProvider>
  );
}
